<div class="login-bg">
	<div class="login-page">
		<div class="login-form">
			<form [formGroup]="resetPasswordFormGroup">
				<img
					src="https://i.ibb.co/XW8Kpnz/mockup-2-1.png"
					alt=""
					class="mobile-img"
				/>
				<mat-card class="form-field">
					<div class="forgot-pass-container">
						<div class="title mb-sm">
							{{ "auth.createNewPass" | translate }}
						</div>

						<mat-card-content>
							<div class="input-with-icon">
								<mat-form-field appearance="outline" class="reset-input">
									<mat-label>{{ "auth.newPass" | translate }}</mat-label>
									<input
										matInput
										[type]="hide ? 'password' : 'text'"
										formControlName="newPassword"
										(ngModelChange)="getNewPasswordLength($event)"
										required
									/>
									<button
										type="button"
										mat-icon-button
										matSuffix
										(click)="hide = !hide"
										[attr.aria-label]="'Hide password'"
										[attr.aria-pressed]="hide"
									>
										<mat-icon>{{
											hide ? "visibility_off" : "visibility"
										}}</mat-icon>
									</button>
									<mat-error
										*ngIf="(f.newPassword.dirty || submitted) && !requiredValid"
										>{{ "error.newPassRequired" | translate }}</mat-error
									>
								</mat-form-field>
								<mat-icon
									class="tooltip-icon"
									[matMenuTriggerFor]="typeTooltip"
									#typeTrigger="matMenuTrigger"
									(mouseenter)="typeTrigger.openMenu()"
								>
									help
								</mat-icon>
								<mat-menu
									#typeTooltip="matMenu"
									[overlapTrigger]="false"
									class="tooltip-popover dashboard"
								>
									<span (mouseleave)="typeTrigger.closeMenu()">
										<ul class="info-detail-css">
											<li>{{ "error.condition_1" | translate }}</li>
											<li>{{ "error.condition_2" | translate }}</li>
											<li>{{ "error.condition_3" | translate }}</li>
										</ul>
									</span>
								</mat-menu>
							</div>

							<mat-form-field appearance="outline" class="reset-input pt-sm">
								<mat-label>{{ "auth.repeatNewPass" | translate }}</mat-label>
								<input
									matInput
									[type]="hide ? 'password' : 'text'"
									formControlName="repeatNewPassword"
									(ngModelChange)="getRepeatNewPasswordLength($event)"
									required
								/>
								<button
									type="button"
									mat-icon-button
									matSuffix
									(click)="hide = !hide"
									[attr.aria-label]="'Hide password'"
									[attr.aria-pressed]="hide"
								>
									<mat-icon>{{
										hide ? "visibility_off" : "visibility"
									}}</mat-icon>
								</button>
								<mat-error
									*ngIf="
										(f.repeatNewPassword.dirty || submitted) && !requiredValid
									"
								>
									{{ "error.repeatPassRequired" | translate }}
								</mat-error>
							</mat-form-field>

							<mat-error
								*ngIf="
									(f.newPassword.dirty &&
										f.newPassword.errors &&
										f.newPassword.errors.requiresDigit) ||
									(f.newPassword.dirty &&
										f.newPassword.errors &&
										f.newPassword.errors.requiresLowercase) ||
									(f.newPassword.dirty &&
										f.newPassword.errors &&
										f.newPassword.errors.requiresSpecialChars)
								"
							>
								{{ "error.alphanumeric" | translate }}
							</mat-error>
							<mat-error
								*ngIf="
									(f.newPassword.dirty && !newPassLength) ||
									(f.repeatNewPassword.dirty && !repeatNewPassLength)
								"
							>
								{{ "error.atLeastLength" | translate }}
							</mat-error>
							<mat-error
								*ngIf="
									f.newPassword.dirty &&
									f.newPassword.errors &&
									f.newPassword.errors.requiresSpecialChars
								"
							>
								{{ "error.oneSpecialChar" | translate }}
							</mat-error>
							<mat-error
								*ngIf="
									(submitted || f.repeatNewPassword.dirty) &&
									f.repeatNewPassword.errors &&
									f.repeatNewPassword.errors.required
								"
							>
								{{ "error.confirmPass" | translate }}
							</mat-error>
							<mat-error
								*ngIf="
									(submitted || f.repeatNewPassword.dirty) &&
									f.repeatNewPassword.errors &&
									f.repeatNewPassword.errors.mismatch
								"
							>
								{{ "error.passNoMatch" | translate }}
							</mat-error>

							<button
								mat-raised-button
								color="primary"
								class="lg"
								(click)="submit()"
								[disabled]="resetPasswordFormGroup.invalid"
							>
								{{ "auth.changePass" | translate }}
							</button>
						</mat-card-content>
					</div>
				</mat-card>
			</form>
		</div>
		<div class="crm-info">
			<img
				src="{{
					isCarsome
						? 'https://storage.googleapis.com/ps-asset/digi_rep/hero/dr_carsome-bg.png'
						: 'https://storage.googleapis.com/ps-asset/digi_rep/hero/dr-bg.png'
				}}"
				alt="mockup-1"
			/>
		</div>
	</div>
</div>
